import { FC } from 'react'
import { borderButton, fullButton, plainButton } from './styles';
import { ButtonProps } from './types';
import { motion } from 'motion/react';
import tinycolor from "tinycolor2";
import settings from '@settings';


const Button: FC<ButtonProps> = ({text, icon, onClick, color='#333', type = 'full', disabled=false, styles={}}) => {
  if (type === 'plain') {
    return (
      <motion.button css={[plainButton(disabled), {...styles}]} onClick={onClick}>
          {icon && icon}
          <span>{text}</span>
          {/* <motion.div css={{backgroundColor: color}} /> */}
      </motion.button>  
    )
  }
  if (type === 'border') {
    return (
      <motion.button css={[borderButton(disabled), {...styles}]} onClick={onClick}>
          {icon && icon}
          {text}
          {/* <motion.div css={{backgroundColor: color}} /> */}
      </motion.button>
    )
  }
  return (
    <motion.button 
        css={[fullButton(disabled), {...styles, backgroundColor: color, color: tinycolor(color).isLight() ? settings.colors.dark : settings.colors.light}]} 
        onClick={onClick}
        disabled={disabled}
      >
        {icon && icon}
        {text}
    </motion.button>
  )
}

export default Button